import React from 'react';
import Section from './section';
import Session from './session';
import Expansion from './components/expansion';
import Element from '../../basic/element';
import './day.scss';

export default class Day extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bookedSessions: this.filterBookedSessions(this.props.data.sections || [])
        }
    }

    static defaultProps = {
        showMyAgenda: false,
        className: '',
        myEmptyAgenda: {},
        myAgendaLoaded: false
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const bookedSessions = Day.prototype.filterBookedSessions(nextProps.data.sections || []);
        return { bookedSessions };
    }

    render() {
        const { data, className } = this.props;

        const content = this.props.bookedView ? this.renderSessions() : this.renderSections()

        return (
            <div className={('day ' + className).trim()}>
                <div className={'title' + this.props.titleClassName}>{this.props.day || data.day}</div>
                {content}
            </div>
        );
    }

    renderMyEmptyAgenda() {
        if (!this.props.myAgendaLoaded) {
            return (
                <div className='loading-container'><div className='pubhub-loading'></div></div>
            );
        }

        const { title, description, action, background } = this.props.myEmptyAgenda;
        const style = background ? { background } : undefined;
        return (
            <div className='my-empty-agenda' style={style}>
                <div className='row'>
                    <div className='col-12 col-md-4'>
                        <div className='col-pic'>
                            <div className='pic'></div>
                        </div>
                    </div>
                    <div className='col-12 col-md-8 col-desc'>
                        <div className='col-desc'>
                            <Element className='title' data={title} />
                            <Element className='desc' data={description} />
                            <div className='action btn btn-primary' onClick={this.props.onGotoFullAgenda}>{action}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderSessions() {
        const data = this.state.bookedSessions;
        const empty = data.filter(i => i.data.booked).length == 0 ? this.renderMyEmptyAgenda() : null;
        const sessions = data.map(i => this.renderSession(i));

        return (
            <div className='booked-sessions'>
                {sessions}
                {empty}
            </div >
        );
    }

    renderSession(session) {
        const { compact, book, onClickSpeaker } = this.props;
        const { data, color } = session;
        return (
            <div key={data.id} className={'booked-session ' + (data.booked ? 'open' : 'close')}>
                <Expansion expanded={data.booked} >
                    <Session
                        removeSectionTimeWithoutTitle={this.props.removeSectionTimeWithoutTitle}
                        embedVideo={this.props.embedVideo}
                        watch={this.props.session.watch}
                        download={this.props.session.download}
                        needSocialLoginIn={this.props.session.needSocialLoginIn}
                        compact={compact}
                        speakerFormat={this.props.speakerFormat}
                        data={data}
                        color={color}
                        book={book}
                        onBeforeUpdateBookmark={this.onBeforeUpdateBookmark}
                        onUpdateBookmark={this.onUpdateBookmark}
                        onClickSpeaker={onClickSpeaker} />
                </Expansion>
            </div>
        );
    }

    renderSections() {
        return (this.props.data.sections || []).map(i => this.renderSection(i));
    }

    renderSection(data) {
        return (
            <Section
                removeSectionTimeWithoutTitle={this.props.removeSectionTimeWithoutTitle}
                watch={this.props.session.watch}
                download={this.props.session.download}
                needSocialLoginIn={this.props.session.needSocialLoginIn}
                embedVideo={this.props.embedVideo}
                key={data.title}
                onBeforeUpdateBookmark={this.onBeforeUpdateBookmark}
                onUpdateBookmark={this.onUpdateBookmark}
                onClickSpeaker={this.props.onClickSpeaker}
                expandedDefault={this.props.expandedDefault}
                compact={this.props.compact}
                hideBookmarks={this.props.hideBookmarks}
                withTime={this.props.sectionWithTime}
                myEmptyAgenda={this.props.myEmptyAgenda}
                speakerFormat={this.props.speakerFormat}
                book={this.props.book}
                onBook={this.props.onBook}
                data={data} />
        );
    }

    filterBookedSessions(data) {
        var list = [];

        data.forEach(i => {
            const filterSessions = i.sessions.filter(s => s.booked).map(s => {
                return { data: s, color: i.color }
            });
            list = [...list, ...filterSessions];
        });

        return list;
    }

    onBeforeUpdateBookmark = (data) => {
        if (this.props.onBeforeUpdateBookmark) {
            return this.props.onBeforeUpdateBookmark({
                ...data,
                book: !data.booked
            });
        }

        return false;
    }

    onUpdateBookmark = (data, callback) => {
        data.booked = !data.booked;
        this.setState({});
        const cb = (err) => {
            if (err) {
                data.booked = !data.booked;
                this.setState({});
            }
            callback && callback(err);
        }
        this.props.onUpdateBookmark && this.props.onUpdateBookmark(data, cb);
    }
}
